import type { ReactNode } from "react";
import { Flex, Progress, Text } from "@chakra-ui/react";

export function PercentageBar({
  percentage,
  label,
  count = null,
}: {
  percentage: number;
  label: string | ReactNode;
  count?: number | null;
}) {
  return (
    <Flex direction={"column"} gap={1}>
      {typeof label === "string" ? (
        <Text fontSize={"md"} fontWeight={500} color={"gray.700"}>
          {label}
        </Text>
      ) : (
        label
      )}

      <Flex
        direction={"row"}
        align={"center"}
        justify={"space-between"}
        gap={5}
      >
        <Progress
          value={percentage}
          h={"8px"}
          borderRadius={"4px"}
          colorScheme={"percentageBar"}
          flexGrow={1}
        />
        <Text fontSize={"md"} fontWeight={500} color={"gray.700"} minW={"32px"}>
          {count ? `${count} ` : `${percentage}%`}
        </Text>
      </Flex>
    </Flex>
  );
}
